export const shadows = {
  none: 'none',
  'level-01': '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
  'level-02': '0px 8px 24px 0px rgba(0, 0, 0, 0.16)',
  'level-03': '0px 16px 32px 0px rgba(0, 0, 0, 0.16)'
};

export type Shadows = typeof shadows;
